<template>

</template>

<script>
    import PreviewElement from "./PreviewElement";
    import ColumnElement from "../../components/pagesbuilder/elements/ColumnElement";

    export default {
        name: "PreviewColumnElement",
        mixins: [PreviewElement,ColumnElement]
    }
</script>
